import {i18n} from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.project.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.project.fields.name'),
  },
  {
    name: 'code',
    label: i18n('entities.project.fields.code'),
  },
  {
    name: 'locations',
    label: i18n('entities.project.fields.locations'),
    render: exporterRenders.relationToManyMap((item) => item.label || item.nombre || item.name),
  },
  {
    name: 'createdAt',
    label: i18n('entities.project.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.project.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
